import React from "react";
import { Card, Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CurrencyValue from "./CurrencyValue";

const ListingCard = ({ size, title, subTitle, data, isAmount, isLoading }) => {
  const { t } = useTranslation();
  return (
    <Col className="mb-3" md={size}>
      <Card bg="dark1" className="h-100">
        <Card.Header className="text-light d-flex justify-content-between">
          <span className="text-uppercase">{t(`${title}`)}</span>
          {subTitle && <span>{t(`${subTitle}`)}</span>}
        </Card.Header>
        <Card.Body>
          {data?.length > 0 && (
            <ul className="list-unstyled">
              {data.map((item, i) => (
                <li key={i} className="d-flex justify-content-between mb-3">
                  <span>{t(`${item.title}`)}</span>
                  {item.status && (
                    <i
                      className={`fa fa-circle text-${
                        item.status === "active" ? "success" : "danger"
                      }`}
                    />
                  )}
                  {isLoading ? (
                    <Spinner size="sm" />
                  ) : item.value && Array.isArray(item.value) ? (
                    <span>{item.value}</span>
                  ) : item.value !== undefined ? (
                    <span>
                      {isAmount
                        ? <CurrencyValue amount={item.value} />
                        : item.value}
                    </span>
                  ) : null}
                </li>
              ))}
            </ul>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
};

export default ListingCard;
